import Std1 from "../../assets/studio/1.jpg";
import Std2 from "../../assets/studio/2.jpg";
import Std3 from "../../assets/studio/3.jpg";
import Std4 from "../../assets/studio/4.jpg";
import Std5 from "../../assets/studio/5.jpg";
import Stdio1 from "../../assets/studio/studio1.jpg";
import Stdio2 from "../../assets/studio/studio2.jpg";
import Stdio3 from "../../assets/studio/studio3.jpg";
import Stdio4 from "../../assets/studio/studio4.jpg";
import Stdio5 from "../../assets/studio/studio5.jpg";
import Stdio6 from "../../assets/studio/studio6.jpg";
import { useRef, useState, useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useTranslation } from "react-i18next";
import { fetchGallery } from "../../services/api";

const FALLBACK_SLIDES = [
  { id: "f1", image_path: Stdio1, alt_text: "" },
  { id: "f2", image_path: Stdio2, alt_text: "" },
  { id: "f3", image_path: Stdio3, alt_text: "" },
  { id: "f4", image_path: Stdio4, alt_text: "" },
  { id: "f5", image_path: Stdio5, alt_text: "" },
  { id: "f6", image_path: Stdio6, alt_text: "" },
];

const Studio = () => {
  const { t } = useTranslation();
  let sliderRef = useRef(null);
  const [slides, setSlides] = useState(FALLBACK_SLIDES);

  useEffect(() => {
    fetchGallery()
      .then((data) => {
        if (data && data.length > 0) setSlides(data);
      })
      .catch(() => {});
  }, []);
  const next = () => {
    sliderRef.slickNext();
  };
  const previous = () => {
    sliderRef.slickPrev();
  };
  const settings = {
    dots: false,
    arrows: false,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 7000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1.5,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  return (
    <div className="Studio-section" id="aboutStudio">
      <div className="w-100 justify-content-between items-start Studio-section-container">
        <h1>{t("About studio")}</h1>
        <div className="Studio-section-imgs">
          <img src={Std1} alt="" width="555"/>
        </div>
      </div>
      <div className="w-100 justify-content-between items-start Studio-section-container ">
        <p>
          {t("firstAbout")}
        </p>
        <div className="Studio-section-imgs">
          <img src={Std2} alt="" width="555" />
        </div>
      </div>
      <div className="w-100 justify-content-between items-start Studio-section-container">
        <p>
          {t("secondAbout")}
        </p>
        <div className="Studio-section-imgs">
          <img src={Std3} alt="" width="555"/>
        </div>
      </div>
      <div className="w-100 justify-content-between items-start Studio-section-container">
        <p>
          {t("thirdAbout")}
        </p>
        <div className="Studio-section-imgs vertical-images">
          <img src={Std4} alt="" width="262"/>
          <img src={Std5} alt="" width="262" />
        </div>
      </div>
      <div className="w-100 d-flex justify-content-between items-start Studio-section-crousel ">
        <h4>{t("More pictures from studio")}</h4>
        <div className=" d-flex justify-content-end align-items-center gap-3 ">
          <div className="left-btn" onClick={previous}>
            <SVGLeft />
          </div>
          <div className="left-btn" onClick={next}>
            <SVGRight />
          </div>
        </div>
      </div>

      <div className="slider-container">
        <Slider
          ref={(slider) => {
            sliderRef = slider;
          }}
          {...settings}
        >
          {slides.map((slide) => (
            <div key={slide.id} className="fist-img">
              <img
                src={slide.image_path}
                alt={slide.alt_text || ""}
                style={{ height: "420px", objectFit: "cover" }}
              />
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default Studio;

export const SVGLeft = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M14 19L7 12L14 5"
        stroke="#07BE72"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const SVGRight = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M9.99976 5L16.9998 12L9.99976 19"
        stroke="#07BE72"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
